import { render } from "./addproduct.vue?vue&type=template&id=47f0630f&scoped=true"
import script from "./addproduct.vue?vue&type=script&lang=js"
export * from "./addproduct.vue?vue&type=script&lang=js"

import "./addproduct.vue?vue&type=style&index=0&id=47f0630f&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f0630f"]])

export default __exports__